module.exports = __webpack_public_path__ + "media/images/google-play-cbd7be1792eeb7dd1eacb6e2f7118f3c.png";